var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfAppointment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 8.512v8.621A1.87 1.87 0 0 1 17.133 19H6.4c-.38 0-.753-.117-1.064-.336A1.85 1.85 0 0 1 5 17.6V8.978a1.87 1.87 0 0 1 1.867-1.866h10.25c.324 0 1.868 1.365 1.867 1.746L19 8.512Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 8.978v.936a.233.233 0 0 1-.233.233H5.233A.233.233 0 0 1 5 9.914v-.936a1.87 1.87 0 0 1 1.867-1.866h10.266A1.87 1.87 0 0 1 19 8.978Z",
  fill: "#F4CC54"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.786 5.798v2.37c0 .44-.356.798-.796.799h-.513a.787.787 0 0 1-.663-.36.795.795 0 0 1-.133-.439v-2.37c0-.44.356-.797.796-.798h.513a.782.782 0 0 1 .436.133c.226.146.361.397.36.665ZM16.786 5.798v2.37c0 .44-.356.798-.796.799h-.513a.787.787 0 0 1-.663-.36.795.795 0 0 1-.133-.439v-2.37c0-.44.356-.797.796-.798h.513a.782.782 0 0 1 .436.133c.226.146.361.397.36.665Z",
  fill: "#405B73"
})));
export default SvgLfAppointment;